import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file useCreateTabItem.ts
 * @author markJia(markjia@tencent.com)
 */
import { useSingleton, useUpdate } from '@tencent/glue-react-use';
import { TabItem } from '@tencent/glue-model-tabs';
import { useEffect } from 'react';
import { useRcTabs } from './useRcTabs';
export var useCreateTabItem = function useCreateTabItem(ops) {
  var id = ops.id,
      _ops$disabled = ops.disabled,
      disabled = _ops$disabled === void 0 ? false : _ops$disabled,
      title = ops.title;
  var update = useUpdate();
  var tabs = useRcTabs();
  var tabItem = useSingleton(function () {
    return new TabItem({
      parent: tabs,
      title: title,
      id: id
    });
  });
  tabItem.updateOptions({
    id: id,
    title: title,
    disabled: disabled
  });
  useEffect(function () {
    tabItem.addListener('item-change', update);
    return function () {
      tabItem.removeListener('item-change', update);
      tabItem.dispose();
    };
  }, []);
  return _objectSpread({
    tabItem: tabItem
  }, tabItem.getData());
};